import React, { Component } from 'react'
import axios from 'axios'
import Auth from '../../Modules/Auth'
import { withCookies, Cookies } from 'react-cookie'
import NumberFormat from 'react-number-format'
import HtmlEditor from '../../Components/Commons/HtmlEditor'
import { renderFiles, renderPDFFiles, renderImageFiles, renderOfficeFiles, renderVideoFiles } from '../Commons/Utils'

class ResultForm extends Component {
    constructor(props) {
        super(props)

        this.state = {
            input: {
                price: '',
                content: '',
            },
            todo: null,
            disabled: false,
        }
    }

    UNSAFE_componentWillMount() {
        this.setState({
            todo: this.props.todo,
            disabled: this.props.disabled,
        })
    }

    addResult = () => {
        if (this.state.input.content === '') {
            alert('내용을 입력해주세요.')
            return
        }

        const confirmText = confirm('완료처리 이후 수정이 불가합니다.')

        if (confirmText) {
            const { cookies } = this.props

            let price = ''
            if (this.state.input.price === '') {
                price = 0
            } else {
                price = this.state.input.price
            }

            axios
                .post(
                    `${BACKEND_HOST}/rfis/${this.props.todo._id}/response`,
                    {
                        changedPrice: Number(price.toString().replace(/,/g, '')),
                        content: this.state.input.content,
                        status: 'CLOSE',
                    },
                    {
                        headers: {
                            Authorization: `bearer ${Auth.getToken()}`,
                        },
                    }
                )
                .then((res) => {
                    console.log(res.data)
                    // this.setState({ todo: res.data, disabled: true });

                    axios
                        .patch(
                            `${BACKEND_HOST}/rfis/${this.props.todo._id}/target/update?target=STATUS&status=CLOSE`,
                            {
                                status: 'CLOSE',
                                target: 'STATUS',
                            },
                            {
                                headers: {
                                    Authorization: `bearer ${Auth.getToken()}`,
                                },
                            }
                        )
                        .then((res) => {
                            alert('완료처리 되었습니다.')
                            this.props.history.push(`/todo/`)
                        })
                        .catch((err) => {
                            console.log(err)
                        })
                })
                .catch((err) => {
                    console.log(err)
                })
        } else {
            return
        }
    }

    // completeResult = () => {
    //   const confirmText = confirm('완료처리 이후 수정이 불가합니다.');

    //   if(confirmText){
    //     alert('완료처리 되었습니다.')
    //   }else{
    //     return;
    //   }

    //   const { cookies } = this.props;
    //   axios.patch(`${BACKEND_HOST}/rfis/${this.props.todo._id}/response`,
    //     {
    //       status: 'CLOSE',
    //       // closeDate: new Date().toISOString(),
    //       // _project: cookies.get('project'),
    //     },
    //     { headers: {
    //       Authorization: `bearer ${Auth.getToken()}`,
    //     },
    //     },
    //   )
    //   .then(res => {
    //     console.log(res.data);

    //     this.setState({
    //       todo: res.data,
    //     })
    //   })
    //   .catch(err => {
    //     console.log(err);
    //   });
    // }

    openResult = () => {
        this.setState({ disabled: false })
    }

    clickModify = () => {
        let changedPrice = ''
        if (this.state.todo.response.changedPrice === 0) {
            changedPrice = ''
        } else {
            changedPrice = this.state.todo.response.changedPrice
        }

        this.setState({
            disabled: false,
            input: { price: changedPrice, content: this.state.todo.response.content },
        })
    }

    closeResult = () => {
        this.setState({
            disabled: true,
        })
    }

    handleModelChange = (model) => {
        const input = this.state.input
        input['content'] = model

        this.setState({
            input,
        })
    }

    changeData = (event) => {
        const field = event.target.name
        const input = this.state.input
        input[field] = event.target.value

        this.setState({
            input,
        })
    }

    Comma = (num) => {
        if (typeof num === 'number') {
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        } else {
            return ''
        }
    }

    render() {
        console.log(this.state)
        if (this.state.todo && this.state.disabled && this.state.todo.response) {
            const newDate = new Date(this.state.todo.updatedAt)
            const newYear = newDate.getFullYear()

            let newMonth = newDate.getMonth() + 1
            if (newMonth < 10) {
                newMonth = '0' + newMonth
            }
            let newDay = newDate.getDate()
            if (newDay < 10) {
                newDay = '0' + newDay
            }
            let newHours = newDate.getHours()
            if (newHours < 10) {
                newHours = '0' + newHours
            }
            let newMinutes = newDate.getMinutes()
            if (newMinutes < 10) {
                newMinutes = '0' + newMinutes
            }

            return (
                <div className="result_wrap">
                    <div className="auth_writer">건축주</div>
                    <h1>건축주 처리 및 결정사항 등록</h1>
                    <div className="result_detail_wrap">
                        <ul className="info_wrap">
                            <li>
                                <p className="label">지출 비용</p>
                                <p className="content price">
                                    {this.Comma(this.state.todo.response.changedPrice)}
                                    <span>원</span>
                                </p>
                            </li>
                        </ul>
                        <p className="textarea_wrap">
                            <div
                                className="inner_html"
                                dangerouslySetInnerHTML={{ __html: this.state.todo.response.content }}></div>
                        </p>
                        {this.state.todo.response.files.length !== 0 && (
                            <div className="text_wrap">
                                <div className="content">{renderFiles(this.state.todo.response.files)}</div>
                            </div>
                        )}
                        {this.state.todo.response.files.length !== 0 && renderPDFFiles(this.state.todo.response.files)}
                        {this.state.todo.response.files.length !== 0 &&
                            renderOfficeFiles(this.state.todo.response.files)}
                        {this.state.todo.response.files.length !== 0 &&
                            renderImageFiles(this.state.todo.response.files)}
                        {this.state.todo.response.files.length !== 0 &&
                            renderVideoFiles(this.state.todo.response.files)}
                        <div className="writer">
                            {this.state.todo.assignee.name} {newYear}.{newMonth}.{newDay}.{newHours}:{newMinutes}
                        </div>
                        {/* {this.props.user._id === this.state.todo.assignee_id && this.state.todo.status !== 'CLOSE' && 
            <div className="btn_wrap">
              <div className="green_line_btn" onClick={this.completeResult}>완료처리</div>
              <div className="ok_btn" onClick={this.clickModify}>수정</div>
            </div>   
          } */}
                    </div>
                </div>
            )
        } else if (this.state.todo && !this.state.disabled && this.props.user._id === this.state.todo.assignee._id) {
            return (
                <div className="result_wrap">
                    <div className="auth_writer">건축주</div>
                    <h1>건축주 처리 및 결정사항 등록</h1>
                    <div className="result_write_wrap">
                        <div className="input_wrap">
                            <p className="price_label">
                                지출 비용
                                {/* 지출 비용 <span>금액 입력시 지출에 등록됩니다.</span>{' '} */}
                            </p>
                            <NumberFormat
                                className="input"
                                type="text"
                                thousandSeparator={true}
                                placeholder="금액을 입력하세요 (ex. 2,000,000)"
                                id="price"
                                name="price"
                                onChange={this.changeData}
                                value={this.state.input.price}
                            />
                            <p className="unit">원</p>
                        </div>
                        <div className="textarea_wrap">
                            <HtmlEditor content={this.state.input.content} handleModelChange={this.handleModelChange} />
                        </div>
                        <div className="btn_wrap">
                            <div
                                className="cancel_btn"
                                onClick={this.props.disabled === 'false' ? this.props.closeResult : this.closeResult}>
                                취소
                            </div>
                            <div className="ok_btn" onClick={this.addResult}>
                                등록
                            </div>
                        </div>
                    </div>
                </div>
            )
        } else {
            return <div></div>
        }
    }
}
export default withCookies(ResultForm)



// WEBPACK FOOTER //
// ./Src/Components/Todo/ResultForm.js